const defaultState = {
    lockFrom: false, // Tracks if user navigated from tree click
};

const mutations = {
    setLockFromState(state, lockFrom) {
        Object.assign(state, { lockFrom });
    },
    resetLockFromState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    setLockFrom({ commit }, lockFrom) {
        commit('setLockFromState', lockFrom);
    },
    resetLockFrom({ commit }) {
        commit('resetLockFromState');
    },
};

const getters = {
    lockFrom: state => state.lockFrom,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
